export function connectedWalletMessageBinding(
  origin: string,
  source: MessageEventSource | null,
  activeFrame: WindowProxy | null | undefined,
  allowedOrigin: string,
): 'accept' | 'reject' | 'ignore' {
  if (source !== activeFrame && origin !== allowedOrigin) return 'ignore';
  return origin === allowedOrigin && source === activeFrame ? 'accept' : 'reject';
}

export function connectedWalletMessage<T>(
  value: T,
): { kind: 'ready' | 'success' | 'error' } | { kind: 'height'; height: number } | null {
  if (!value || typeof value !== 'object') return null;
  const event =
    ('event' in value ? value.event : undefined) ?? ('type' in value ? value.type : undefined);
  if (event === 'onReady') return { kind: 'ready' };
  if (event === 'onSuccess') return { kind: 'success' };
  if (event === 'onError') return { kind: 'error' };
  if (event !== 'onHeightChanged') return null;
  const height = 'height' in value ? value.height : undefined;
  return typeof height === 'number' && Number.isFinite(height)
    ? { kind: 'height', height: Math.min(900, Math.max(420, Math.round(height))) }
    : null;
}
